export default __webpack_public_path__ + "static/media/WashingtonAnswer2.98744342.png";